<template>
    <v-container fluid class="pa-0">
      <v-row no-gutters>
        <v-col
          class="d-flex bg-cyan-darken-4 mx-3 px-4 py-4"
          :style="{
            fontSize: '16px',
            width: '98%',
            borderTopLeftRadius: '1rem',
            borderTopRightRadius: '1rem',
          }"
        >
          {{ currentLocal === 'ar'
            ? $t(getPluralKey(pluralKey, itemCount), itemCount)
            : $t(translationKey, itemCount) }}
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    props: {
      currentLocal: {
        type: String,
        required: true,
      },
      itemCount: {
        type: Number,
        required: true,
      },
      translationKey: {
        type: String,
        required: true,
      },
      pluralKey: {
        type: String,
        required: true,
      },
    },
    methods: {
    },
  };
  </script>
  
  <style scoped>
  /* Add any additional styles if needed */
  </style>
  